<div class="container v2">
  <div
    class="safeaArea"
    [ngStyle]="{
      'padding-top.px': skipSafeAreaTop() ? 0 : safeAreaTop,
      'padding-bottom.px': safeAreaBottom,
    }"
  >
    <ng-content></ng-content>
  </div>
</div>
